import ShopifyNew from './shopify-new';

export default ShopifyNew;
